import { useState } from "react";
import { toast } from "sonner";
import { Copy, ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * 149-ar: Modal one-time reveal password sementara setelah admin reset.
 * Password TIDAK disimpan di state global — hanya di prop ini sampai dialog ditutup.
 * User diharuskan copy + share via channel aman lalu tutup — password TIDAK bisa
 * dilihat lagi kecuali reset ulang.
 */
export default function TempPasswordDialog({ open, onOpenChange, user, tempPassword }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(tempPassword);
      setCopied(true);
      toast.success("Password sementara disalin ke clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Gagal menyalin — copy manual dari field"); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-md" data-testid="dialog-temp-password">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight flex items-center gap-2"><ShieldAlert className="text-[#FF5A1F]" size={20} /> Password Sementara</DialogTitle>
          <DialogDescription>
            Password sementara untuk <b>{user?.name}</b> ({user?.email}). Password ini <b>HANYA muncul di layar ini</b> — sistem <b>tidak menyimpan plaintext</b>. Segera copy + share via channel aman (WhatsApp/Signal), lalu tutup dialog ini.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <div className="border-2 border-amber-400 bg-amber-50 p-4 flex items-center justify-between gap-3">
            <span data-testid="temp-password-value" className="font-mono text-xl tracking-wider text-[#0B1D3A] select-all">{tempPassword}</span>
            <Button
              type="button"
              onClick={copy}
              data-testid="btn-copy-temp"
              className="rounded-none bg-[#FF5A1F] hover:bg-[#e04a13] text-white uppercase text-xs tracking-wider font-semibold"
            ><Copy size={12} className="mr-1" /> {copied ? "Copied!" : "Copy"}</Button>
          </div>
          <ul className="text-[11px] text-slate-600 space-y-1 pl-4 list-disc">
            <li>User <b>WAJIB ganti password</b> saat login berikutnya.</li>
            <li>Semua sesi aktif user ini sudah otomatis di-kick.</li>
            <li>Setelah dialog ditutup, password ini tidak dapat dilihat ulang.</li>
          </ul>
        </div>

        <DialogFooter>
          <Button
            type="button"
            data-testid="btn-close-temp"
            variant="outline"
            className="rounded-none"
            onClick={() => onOpenChange(false)}
          >Sudah Disalin — Tutup</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
